import { createContext, useContext, useEffect, useState } from "react";
import { decrypt, encrypt } from "../Misc";

// Create the UserContext
const UserContext = createContext();

// Create the UserProvider component
export function UserProvider({ children }) {
  const [userData, setUserData] = useState(null);
  const [permission, setPermission] = useState(null);

  // Load from localStorage on mount
  useEffect(() => {
    if (localStorage.getItem("userData")) {
      const storedUser = decrypt(localStorage.getItem("userData"));
      if (storedUser) {
        let data = JSON.parse(storedUser);
        let permissionData =
          data?.permissions?.length === 0 || data?.permissions === null
            ? data?.role?.permissions
            : data?.permissions;
        setPermission(permissionData);
        setUserData(JSON.parse(storedUser));
      }
    }
  }, []);

  // Persist to localStorage on change
  useEffect(() => {
    if (userData) {
      let data = userData;
      
      let permissionData =
        data?.permissions?.length === 0 || data?.permissions === null
          ? data?.role?.permissions
          : data?.permissions;
      setPermission(permissionData);
      localStorage.setItem("userData", encrypt(JSON.stringify(userData)));
    } else {
      localStorage.removeItem("userData");
    }
  }, [userData]);

  // Function to update project data conditionally
  const updateUserData = (newData) => {
    setUserData((prevData) => (prevData !== newData ? newData : prevData));
  };

  // Define the context value object
  const contextValue = {
    userData,
    updateUserData,
    permission,
  };

  return (
    <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
  );
}

// Custom hook to use the UserContext
export function useUser(org = false) {
  const context = useContext(UserContext);
  if (org) {
    return { userId: "" };
  }
  if (!context) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return context;
}
